// @flow
import type { FieldBorderOperationsById } from 'fc-operator-fieldborder/types'
import type { Asset } from 'fc-model-assets/types'

// Libs
import React, { Component } from 'react'
import _map from 'lodash/map'
import _size from 'lodash/size'
import _head from 'lodash/head'

// Localization
import { FormattedMessage } from 'react-intl'
import messages from '../messages'

// Components
import UploadFieldBorder from './UploadFieldBorder'
import Button from '@react-mdc/button'

// Styles
const styles = {
  container: {
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    width: 300,
    backgroundColor: '#fff',
    color: '#fff',
    boxShadow: '-2px 0 2px rgba(0, 0, 0, 0.2)',
    padding: 15,
    overflow: 'auto',
  },
  buttons: {
    display: 'flex',
    flexDirection: 'row',
    width: 300,
    justifyContent: 'flex-end',
    padding: 5,
  },
  button: {
    marginRight: 5,
  },
  warning: {
    color: 'red',
    textAlign: 'center',
    margin: '30px 0',
  },
}

type Props = {
  uploadOperations: FieldBorderOperationsById,
  onChange: Function,
  onCancel: Function,
  onSubmit: Function,
  assets: Array<Asset>,
  displayWarning: boolean,
}

export default class UploadFieldBorders extends Component {
  props: Props
  onSubmit: Function
  onCancel: Function

  constructor(props: Props) {
    super(props)

    this.onSubmit = this.onSubmit.bind(this)
    this.onCancel = this.onCancel.bind(this)
    this.getSource = this.getSource.bind(this)

    this.state = {
      warningConfirmed: false,
    }
  }

  onSubmit(e: Event) {
    e.preventDefault()

    if (this.props.displayWarning && !this.state.warningConfirmed) {
      this.setState({
        warningConfirmed: true,
      })
    } else {
      this.props.onSubmit(this.props.uploadOperations)
    }
  }

  onCancel(e: Event) {
    e.preventDefault()

    this.props.onCancel(this.props.uploadOperations)
  }

  renderOperations(): Array<React.Element<any>> {
    return _map(this.props.uploadOperations, (uploadOperation: FieldBorderOperation): React.Element<any> => {
      return (
        <UploadFieldBorder
          key={uploadOperation.operationId}
          uploadOperation={uploadOperation}
          onChange={this.props.onChange}
          assets={this.props.assets}
        />
      )
    })
  }

  getSource(): string {
    if (_size(this.props.uploadOperations) > 1) {
      return 'assets'
    } else {
      return _head(_map(this.props.uploadOperations)).model.source
    }
  }

  render(): ?React.Element<any> {
    if (_size(this.props.uploadOperations)) {
      const source = this.getSource()
      return (
        <form
          style={source === 'assets' ? styles.container : { ...styles.container, width: 320 }}
          onSubmit={this.onSubmit}
        >
          {this.props.displayWarning && !this.state.warningConfirmed ? (
            <div style={styles.warning}>
              <FormattedMessage {...messages['existingBorderWarning']} />
            </div>
          ) : (
            this.renderOperations()
          )}
          <div style={source === 'assets' ? styles.buttons : { ...styles.buttons, width: 320 }}>
            <Button raised primary style={styles.button} onClick={this.onSubmit}>
              {this.props.displayWarning && !this.state.warningConfirmed ? 'Confirm' : 'Submit'}
            </Button>
            <Button raised style={styles.button} primary onClick={this.onCancel}>
              {'Cancel'}
            </Button>
          </div>
        </form>
      )
    }

    return null
  }
}
